import { render, staticRenderFns } from "./AddGroupCompany.vue?vue&type=template&id=75447488&scoped=true&"
import script from "./AddGroupCompany.vue?vue&type=script&lang=js&"
export * from "./AddGroupCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75447488",
  null
  
)

export default component.exports